<template>
    <div id="form-grid" class="form-grid-wrapper col-12 d-flex justify-content-center" v-bind:class="{iosPadding: isIOSMobileDevice}">
        <div class="form-grid-subwrapper">
            <div class="form-grid-modal col-12 col-md-10 my-1">
                <img :src="getImage('close-icon', 'svg')" v-on:click="toggleFormGridVisibilityCallback" class="d-none d-md-block form-grid-modal-close-button btn">
                <div class="row no-gutters align-items-center justify-content-center">
                    <div class="d-md-none col-12 col-md-4">
                        <div class="form-grid-info-header py-2">
                            <img :src="getImage('close-icon-white', 'svg')" v-on:click="toggleFormGridVisibilityCallback" class="d-md-none form-grid-modal-close-button btn">
                            <div class="row no-gutters justify-content-center">
                                <span class="text form-grid-info-header-venue">{{selectedFormGrid.raceVenue}}</span>
                            </div>
                            <div class="row no-gutters justify-content-center">
                                <span class="form-grid-info-header-distance text">{{selectedFormGrid.distance}}m</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-7 col-md-4 d-flex flex-column align-items-center">
                        <div class="d-flex flex-column">
                            <span class="form-grid-header-text">{{selectedFormGrid.raceDate}}</span>
                            <span class="form-grid-header-text">{{selectedFormGrid.meritRating}}</span>
                            <span class="form-grid-header-text">Stake: {{selectedFormGrid.stake | currency('R', 0, { thousandsSeparator: ' ' })}}</span>
                            <span class="form-grid-header-text">Going: {{selectedFormGrid.going}}</span>
                        </div>
                    </div>
                    <div class="d-none d-md-flex col-12 col-md-4 justify-content-center">
                        <div class="form-grid-info-header py-2 px-5">
                            <div class="row no-gutters justify-content-center">
                                <span class="text form-grid-info-header-venue">{{selectedFormGrid.raceVenue}}</span>
                            </div>
                            <div class="row no-gutters justify-content-center">
                                <span class="form-grid-info-header-distance text">{{selectedFormGrid.distance}}m</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-5 col-md-4 text-center">
                        <div class="row no-gutters justify-content-center">
                            <img class="race-track-icon"
                                 :src="getImage(
                                 `${raceCourseAssets[selectedFormGrid.raceTrackAssetId].raceCourseIcon}-${selectedFormGrid.distance}`,
                                 'svg',
                                 raceCourseAssets[selectedFormGrid.raceTrackAssetId].raceCourseIcon
                                 )"/>
                        </div>
                        <!--<img class="race-card-course-image img-fluid" :src="getImage(`${raceCourseAssets[selectedFormGrid.raceTrackAssetId].raceCourseIcon}-${raceCard.raceInformation[selectedRace.raceByRace.raceNumber - 1].distance}`)"/>-->

                    </div>
                </div>
                <div id="race-numbers" class="row no-gutters d-flex justify-content-center align-items-center">
                    <div class="col-12 col-lg-6 text-center">
                        <div  class="row no-gutters d-flex justify-content-center align-items-center">
                            <button class="race-number-button" v-for="(race, index) in selectedFormGrid.races" :key="index" v-bind:class="{'race-number-button-selected': selectedFormGrid.id === race.raceGuidId}" @click="onRaceSelected(race.raceGuidId)">{{index + 1}}</button>
                        </div>
                    </div>
                </div>

                    <div v-if="isVisible" >
                 <button class="btn btn-primary" @click="GoBack()" >Back</button>
                    </div>

                <div class="row no-gutters mt-1">
                    <div id="form-grid-table" class="table-responsive">
                        <table v-bind:class="{'table-sm': displaySmallTable}" class="table">
                            <thead class="thead-dark">
                            <tr>
                                <th scope="col">PREVIOUS RACE</th>
                                <th id="horse-number" scope="col">#</th>
                                <th scope="col">HORSE</th>
                                <th scope="col">FIN</th>
                                <th scope="col">LBH</th>
                                <th scope="col">WEIGHT</th>
                                <th scope="col">EQ</th>
                                <th scope="col">DR</th>
                                <th scope="col">MR</th>
                                <th scope="col">A/S</th>
                                <th scope="col">JOCKEY</th>
                                <th scope="col">TRAINER</th>
                                <th scope="col">TIME</th>
                                <th scope="col">SP</th>
                                <th scope="col">POST&nbsp;RACE</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-bind:class="{'previously-selected-horse': raceResult.wasPreviousRace, 'scratched': raceResult.runnerStatus === 2}"
                                v-for="(raceResult, index) in selectedFormGrid.raceResults" :key="index">
                                <td class="justify-content-end" scope="row" v-bind:class="{'d-flex': (raceResult.previousRaceResults.length > 0)}">
                                    <previous-finish-position
                                            v-for="(position, index) in raceResult.previousRaceResults" :key="index"
                                            v-bind:class="{'race-hovered': position.isInHoveredRace}"
                                            :positionId="'prePosition' + index"
                                            :finish-position="position"
                                            :onClickCallback="onSeparateRaceClicked"
                                            :onHover="onSeparateRaceHover"
                                            :onHoverOut="onSeparateRaceHoverOut"                                     
                                    ></previous-finish-position>
                                </td>
                                <td>{{raceResult.horseNumber}}</td>
                                <td class="text-left clickable-text font-weight-bold"
                                    v-on:click="onHorseNameClicked(raceResult.horseName)">{{raceResult.horseName}}
                                </td>
                                <td v-if="(raceResult.position <= 5)"><img
                                        :src="getImage('wf-finishing-position-' + raceResult.position, 'svg')"
                                        class="finishing-position-icon-form-grid"></td>
                                <td v-if="(raceResult.position > 5)">{{raceResult.position}}</td>
                                <td>{{raceResult.lengthsBehind}}</td>
                                <td class="font-weight-bold">{{raceResult.weight | wgtdecimalpoint }}</td>
                                <td>{{raceResult.equipment}}</td>
                                <td>{{raceResult.draw}}</td>
                                <td>{{raceResult.meritRating}}</td>
                                <td>{{raceResult.ageAndSex}}</td>
                                <td class="text-left clickable-text"
                                    v-on:click="onJockeyNameClicked(raceResult.jockeyName)">{{raceResult.jockeyName | jockeyinit | init }}
                                </td>
                                <td class="text-left">{{raceResult.trainer | init }}</td>
                                <td>{{raceResult.time}}</td>
                                <td>{{raceResult.startingPrice}}</td>
                                <td class="text-left" scope="row" v-bind:class="{'d-flex': (raceResult.postRaceResults.length > 0)}">
                                    <previous-finish-position
                                            v-for="(position, index) in raceResult.postRaceResults" :key="index"
                                            v-bind:class="{'race-hovered': position.isInHoveredRace}"
                                            :positionId="'postPosition' + index"
                                            :finish-position="position"
                                            :onClickCallback="onSeparateRaceClicked"
                                            :onHover="onSeparateRaceHover"
                                            :onHoverOut="onSeparateRaceHoverOut"
                                    ></previous-finish-position>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex';
    import PreviousFinishPosition from './PreviousFinishPosition';
    import {RaceCourseAssets} from './configuration/raceCourseAssetMapping.constant';
    import {FormGridService} from '../services/formGrid.service';
    import jockeyTrainer from '../components/mixins/Jockey-TrainerName'

    export default {
        name: 'FormGridModal',
         mixins:[jockeyTrainer],
        components: {
            PreviousFinishPosition
        },
        data: function () {
            return {
                displaySmallTable: false,
                raceCourseAssets: RaceCourseAssets,
                isIOSMobileDevice: !!navigator.platform.match(/iPhone|iPod|iPad/),
                isVisible:false,
                raceid:[],
                prevID:[],
            };
        },
        props: {
            toggleFormGridVisibilityCallback: Function,
            separateRaceHorseIndex: Number
        },
        computed: mapState(['selectedFormGrid']),
        created: function() {
            this.setPreviouslySelectedHorse();
        },
        filters:{
            wgtdecimalpoint:function(value){
                value=value.toString()
                if(value!=null && !value.includes('(') && !value.includes('.')){
                    value=value+'.0'
                }
                else if(value!=null && value.includes('(')){
                    if(!value.includes('.')){
                        value=value.replace(')','.0)')
                    }
                    value=value.replace('(','.0(')
                   
                }
                return value
            }
        },
        methods: {
            getGridId(){
            this.prevID.push(this.selectedFormGrid.id)
                this.prevID.pop();
            },
            GoBack(){
                if(this.raceid.length>0){
               this.onRaceSelected(this.raceid[this.raceid.length-1])
               this.raceid.pop();
               if(this.raceid==null){
                   this.isVisible=!this.isVisible
               }
                }else{this.isVisible=!this.isVisible}
            },
        getRaceId(){
                this.raceid.push(this.selectedFormGrid.id) 
               
            },
            getImage(imagePath, fileType = 'svg', defaultRaceCoursePath) {
                try {
                    return require('../assets/images/' + imagePath + '.' + fileType);
                }
                catch (e) {
                    return require('../assets/images/' + defaultRaceCoursePath + '.' + fileType);
                }
            },
            setTableState() {
                if (window.innerWidth < 1200) this.displaySmallTable = true;
            },
            onHorseNameClicked() {
                this.setSelectedHorse({});
                // this.$router.push('/landing/statistics');
            },
            onJockeyNameClicked() {
                this.setSelectedJockey({});
                // this.$router.push('/landing/statistics');
            },
            onSeparateRaceClicked(separateRaceHorsePosition) {
                this.separateRaceHorseIndex = separateRaceHorsePosition;
                this.getRaceId()
                if(this.raceid!=null){
                    this.isVisible=true
                }
    
                 this.getGridId()
            },
            onSeparateRaceHover(raceId) {
                this.selectedFormGrid.raceResults.forEach((raceResult) => {
                    raceResult.previousRaceResults.forEach((previousRaceResult) => {
                        if (previousRaceResult.raceId === raceId) {
                            previousRaceResult.isInHoveredRace = true;
                        }
                    });
                    raceResult.postRaceResults.forEach((postRaceResult) => {
                        if (postRaceResult.raceId === raceId) {
                            postRaceResult.isInHoveredRace = true
                        }
                    });
                })
            },
            onSeparateRaceHoverOut() {
                this.selectedFormGrid.raceResults.forEach((raceResult) => {
                    raceResult.previousRaceResults.forEach((previousRaceResult) => {
                        previousRaceResult.isInHoveredRace = false;
                    });
                    raceResult.postRaceResults.forEach((postRaceResult) => {
                        postRaceResult.isInHoveredRace = false;
                    });
                })
            },
            onRaceSelected(raceGuid) {
                FormGridService.getFormGrid(raceGuid, () => {});
            },
            setPreviouslySelectedHorse(currentPreviousResults = this.selectedFormGrid.raceResults) {
                currentPreviousResults.forEach((raceResult, index) => {
                    // if(!this.selectedFormGrid.raceResults[index - 1]) debugger;
                    if(index === this.separateRaceHorseIndex) this.selectedFormGrid.raceResults[index - 1].wasPreviousRace = true;
                });
            },
            setHorizontalScroll() {
                const element = document.getElementById('horse-number'),
                    scrollLeft = (element.offsetLeft - element.scrollLeft + element.clientLeft);
                document.querySelector('#form-grid-table').scrollLeft = scrollLeft - 12;
            },
            onUpdate(currentPreviousResults = this.selectedFormGrid.raceResults) {
                this.setPreviouslySelectedHorse(currentPreviousResults);
                // this.setHorizontalScroll();
            },
            ...mapMutations(['setSelectedHorse', 'setSelectedJockey'])
        },
        watch: {
            selectedFormGrid: function (newVal, oldVal) {
                this.onUpdate(newVal.raceResults); 
            }
        },
        mounted: function () {
            this.setTableState();
            this.formGridElement = document.querySelector('#form-grid');
            window.onresize = this.setTableState;

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .iosPadding {
        padding-bottom: 5rem !important;
    }

    #race-numbers {
        background-color: #FFFFFF;
        padding: 0.6rem 0;
        /*border: solid #000000 1px;*/
    }

    .race-number-button {
        margin-right: 0.1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.7rem;
        font-weight: normal;
        color: #FFFFFF;
        background-color: #000000;
        border: solid 1px #000000;
    }

    .race-number-button-selected {
        background-color: #FFFFFF;
        color: #000000;
        cursor: pointer;
    }

    .race-number-button:hover {
        background-color: #FFFFFF;
        color: #000000;
        cursor: pointer;
    }

    .race-hovered {
        background-color: black;
    }

    .previously-selected-horse {
        background-color: #DFDFDF;
    }

    .scratched {
        background-color: rgba(184, 15, 10, 0.51);
    }

    .table td {
        vertical-align: middle !important;
        text-align: center;
    }

    th {
        text-align: center;
    }

    .form-grid-info-header {
        position: relative;
        background-color: #000000;
        border-radius: 0.4rem;
        border: none;
    }

    .form-grid-info-header-venue {
        font-size: 0.8rem;
    }

    .form-grid-info-header-distance {
        font-size: 1.1rem;
        font-weight: bold;
    }

    button:hover {
        background-color: #F0F0F0;
        cursor: pointer;
    }

    .form-grid-wrapper {
        position: absolute;
        top: 0;
        height: 100vh;
        background: rgba(0, 0, 0, 0.6);
        z-index: 11;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }

    .form-grid-subwrapper {
        position: relative;
        display: flex;
        justify-content: center;
        margin: auto;
        width: 100%;
    }

    .form-grid-modal {
        background-color: #FFFFFF;
        border-radius: 6px;
        border: solid 1px #000000;
        padding: 1rem 0.7rem 2.3rem 0.7rem;
        margin-bottom: 2rem !important;
    }

    .form-grid-modal-close-button {
        position: absolute;
        top: 0.1rem;
        right: 0.1rem;
        width: 40px;
        z-index: 5;
    }

    .form-grid-header-text {
        font-size: 0.8rem;
        font-weight: bolder;
    }

    .finishing-position-icon-form-grid {
        height: 18px;
    }

    .table th {
        font-size: 0.5rem;
        white-space: nowrap;
    }

    .race-track-icon {
        height: 100% !important;
        width: 100%;
        margin: 0.5rem;
    }

    td {
        font-size: 0.7rem !important;
        white-space: nowrap;
    }

    @media (min-width: 768px) {
        .race-number-button {
            font-size: 1.1rem;
        }

        td {
            font-size: 0.8rem !important;
        }


        .race-track-icon {
            height: 125px !important;
        }
    }

    @media (min-width: 1200px) {
        .race-number-button {
            font-size: 1.4rem;
            padding-left: 0.7rem;
            padding-right: 0.7rem;
        }

        .finish-position-legend-item {
            line-height: 1.8rem;
        }

        .form-grid-wrapper {
            height: 100%;
            top: 0 !important;
            position: absolute !important;
            z-index: 10;
        }

        .form-grid-modal {
            padding: 0.5rem 0.5rem 1.5rem 0.5rem;
        }

        .form-grid-header-text {
            font-size: 1.2rem;
            font-weight: bolder;
        }

        .finishing-position-icon-form-grid {
            height: 20px;
        }

        .table th {
            font-size: 0.9rem;
        }

        .table td {
            padding: 0.35rem 0.75rem !important;
        }

        .form-grid-info-header-venue {
            font-size: 1.3rem;
        }

        .form-grid-info-header-distance {
            font-size: 1.4rem;
        }
    }

    @media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: landscape) {
        .race-track-icon {
            width: 65% !important;
        }

        table th {
            font-size: 1rem !important;
        }

        .form-grid-modal {
            padding: 1.5rem 0.5rem;
        }

        .form-grid-info-header-venue {
            font-size: 1.3rem;
        }

        .form-grid-info-header-distance {
            font-size: 1.4rem;
        }

        .form-grid-header-text {
            font-size: 1rem;
        }
    }

</style>
